<template>
  <VWidget enable-footer-actions>
    <template slot="title">
      <slot name="title" :entity="boardItem.entity">{{ boardItem.entity ? boardItem.entity.display : '' }}</slot>
    </template>
    <template slot="header-actions">
      <v-menu bottom left min-width="150" v-if="$entity.isAllowed('update', boardItem.entity)">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon small class="mr-2">
            <v-icon small v-text="$vuetify.icons.values.options" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="showProperties" v-if="$entity.isAllowed('update', boardItem.entity)">
            <v-list-item-title>{{ $t('labels.properties') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showUsers" v-if="$entity.isAllowed('manage', boardItem.entity)">
            <v-list-item-title>{{ $t('labels.users') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="archive" v-if="$entity.isAllowed('destroy', boardItem.entity)">
            <v-list-item-title>{{ $t('labels.archive') }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="destroy" v-if="$entity.isAllowed('destroy', boardItem.entity)">
            <v-list-item-title>{{ $t('labels.delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon small @click="dismiss">
        <v-icon small>{{ $vuetify.icons.values.close }}</v-icon>
      </v-btn>
    </template>

    <template slot="content">
      <router-view></router-view>
      <slot name="content" :boardItem="boardItem" :proxy="proxy">
        <StateStepper :board-item="boardItem" :include="include" />
        <Tags :boardItem="boardItem" :key="`tags-${boardItem.entity.id}`" />
      </slot>
      <v-card flat class="elevation-0" v-if="boardItem.entity.users">
        <v-card-text class="pa-0">
          <h6 class="text-caption text-right grey--text">
            {{ $t('assignedUsers') }}
          </h6>
          <AvatarList :users="boardItem.entity.users" align-right />
        </v-card-text>
      </v-card>
      <slot name="tabs" :boardItem="boardItem" v-if="!hideTabs">
        <entity-tabs :board-item="boardItem" />
      </slot>
    </template>

    <template slot="footer-actions">
      <div class="text-caption grey--text">
        <span class="lighten-3">{{ $t('labels.createdOn') }}</span>
        <span class="font-weight-bold">{{ transformDate(boardItem.entity.created_on) }}</span>
        <span>•</span>
        <span class="lighten-3">{{ $t('labels.updatedOn') }}</span>
        <span class="font-weight-bold">{{ transformDate(boardItem.entity.updated_on) }}</span>
      </div>
    </template>
  </VWidget>
</template>

<script>
import { formatDT } from '@argon/app/helpers'
import { NAMESPACE as ME_NAMESPACE } from '@argon/iam/me/store'
import { VWidget } from '@argon/app/components'
import { Tags } from '@argon/evo/addons/components'
import { AvatarList } from '@argon/iam/components'

import { EntityTabs, StateStepper } from '../components'
import entityPerimeter from '../perimeters'

export default {
  name: 'EntityCardWidget',
  components: {
    VWidget,
    Tags,
    EntityTabs,
    StateStepper,
    AvatarList
  },
  perimeters: [entityPerimeter],
  props: {
    hideTabs: { type: Boolean, default: false },
    boardItem: { type: Object, required: true },
    proxy: { type: String, required: true },
    include: { type: String, required: true },
    dismiss: { type: Function, required: true },
    archive: { type: Function, required: true },
    destroy: { type: Function, required: true },
    showProperties: { type: Function, required: true },
    showUsers: { type: Function, required: true }
  },
  computed: {
    timezone() {
      return this.$store.getters[`${ME_NAMESPACE}/timezone`]
    }
  },
  methods: {
    transformDate(value) {
      return value ? formatDT(value, { format: 'LLL', tz: this.timezone }) : ''
    }
  }
}
</script>

<i18n>
{
  "en": {
    "assignedUsers": "Assigned Users"
  },
  "fr": {
    "assignedUsers": "Utilisateurs assignés"
  }
}
</i18n>
